import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpInterceptor,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map, tap } from 'rxjs/operators';
import { LanguageService } from '../../language.service';
import { AuthService } from './auth.service';
import { HelperMethodService } from './helper-method.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private helperMethod: HelperMethodService,
    private authService: AuthService,
    private language: LanguageService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.language.lang_beh.subscribe((res) => {
      if (res == 'ar') {
        req = req.clone({
          setHeaders: {
            'Accept-Language': `ar-EG,ar;q=0.9,en-US;q=0.8,en;q=0.7`,
            company: 'eyJxoGciOiJIzI1N5iIsAnI5cCI6IkpXLCJ9.ezJ0b2tsll90e',
          },
        });
      } else if (res == 'en') {
        req = req.clone({
          setHeaders: {
            'Accept-Language': `en-US,en;q=0.9,ar-EG;q=0.8,ar;q=0.7`,
            company: 'eyJxoGciOiJIzI1N5iIsAnI5cCI6IkpXLCJ9.ezJ0b2tsll90e',
          },
        });
      }
    });

    if (
      (req.url.endsWith('BranchLogInView/') && req.method == 'POST') ||
      (req.url.includes('UserCreateUpdate') && req.method == 'POST') ||
      (req.url.includes('LogInView') && req.method == 'POST') ||
      (req.url.endsWith('LoginWithFacebookView') && req.method == 'POST')
    ) {
      console.log('iiiiif interceptor');
      return next.handle(req).pipe(
        map((event) => {
          if (event instanceof HttpResponse) {
            if (event.body.token) {
              const token = event.body.token;
              localStorage.setItem('bogo_token', token);
              this.authService.token_beh.next(token);
            }
            return event;
          }
        })
      );
    } else if (
      (req.url.endsWith('auth/mobile/signup/') && req.method == 'POST') ||
      (req.url.endsWith('auth/mobile/login/') && req.method == 'POST')
    ) {
      return next.handle(req).pipe(
        map((event) => {
          if (event instanceof HttpResponse) {
            if (event.body.key) {
              console.log(event);
              const token = event.body.key;
              localStorage.setItem('bogo_token', token);
              this.authService.token_beh.next(token);
              this.authService.getProfileData().subscribe((res: any) => {
                localStorage.setItem(
                  'user_data',
                  JSON.stringify(res.results[0])
                );
                this.authService.user_data.next(res.results[0]);
              });
            }
            return event;
          }
        })
      );
    } else {
      const token = localStorage.getItem('bogo_token');
      this.authService.token_beh.next(token);
      if (token) {
        // this.userServ.token_beh.next(token);
        req = req.clone({ setHeaders: { Authorization: `Token ${token}` } });
        req = req.clone({ setHeaders: { 'Content-Type': `application/json` } });

        return next.handle(req).pipe(
          tap(
            (event) => {
              if (event instanceof HttpResponse) {
              }
            },
            (error) => {
              // http response status code
              if (error.status == 401 || error.status == 500) {
                // this.helperMethod.presentToastr('token invalid or expired');
                localStorage.clear();
                location.replace('/');
              }
            }
          )
        );
      } else {
        req = req.clone({ setHeaders: { 'Content-Type': `application/json` } });
        return next.handle(req);
      }
    } //else
  } //else
}
